import React from 'react';
import * as yup from 'yup';
import { StyleProps } from '$/components/ui';

import {
  AttendeeFragment,
  InteractionForAttendeeFragment,
  InteractionFragment,
  PublicEWebinarFragment,
  ReactionFragment,
} from '$/GraphQL/schema/types';
import { TipIcon } from '$/images/FontAwesomeIcons';
import { RenderColumnData } from '$/sections/Home/Dashboard/Registrants/types';

import { InteractionInfo, InteractionModalFooterProps, NoBodyCard } from '../InteractionInfo';

import { AnalyticsCardProps } from '../cards/types';
import { InteractionModalComponentProps, InteractionModalAccordionsHook } from '../types';

import CardMain from '../cards/CardMain';

const TipModalCard = React.lazy(() => import('./TipModal'));
const AnalyticsClickCard = React.lazy(() => import('../cards/AnalyticsClickCard'));

export class TipInfo extends InteractionInfo {
  public constructor(
    i: InteractionForAttendeeFragment | InteractionFragment,
    ewebinar?: PublicEWebinarFragment,
    attendee?: AttendeeFragment
  ) {
    super(i, ewebinar, attendee);
  }

  public typeName(): string | undefined {
    return 'Tip';
  }

  public userCanAdd(): boolean {
    return true;
  }

  public category(): 'Standard' | 'Special' | 'Anchor' | 'Conversion' {
    return 'Standard';
  }

  public hasExpiresInField(): boolean {
    return false;
  }

  public hasShowTimerToggle(): boolean {
    return false;
  }

  public onlyOneInstance(): boolean {
    return false;
  }

  public hasResultsAppearAtField(): boolean {
    return false;
  }

  public hasPropertyNameField(): boolean {
    return false;
  }

  public hasPinToTopToggle(): boolean {
    return true;
  }

  public hasEndsAt(): boolean {
    return false;
  }

  public isInteractiveCard(): boolean {
    return false;
  }

  public isVisibleToAttendee(): boolean {
    return true;
  }

  public hasEngagement(): boolean {
    return false;
  }

  public attendeeCardValidationRules(): yup.AnyObjectSchema | undefined {
    return undefined;
  }

  public icon(): React.FC<StyleProps> {
    return TipIcon;
  }

  public isEditable(): boolean {
    return true;
  }

  public detailsKey(): string | undefined {
    return undefined;
  }

  // Does the interaction generate Answers
  // (Click doesn't count as its simply a reaction not an answer)
  public hasAnswers(): boolean {
    return false;
  }

  // Where does primary answer live?
  public answerMessage(
    _reaction: Pick<ReactionFragment, 'stringAnswer' | 'numberAnswer' | 'detailsFields'>
  ): string {
    return '';
  }

  public useModalPreviewComponent(): React.LazyExoticComponent<
    React.FC<InteractionModalComponentProps>
  > | null {
    return TipModalCard;
  }

  public modalSettingsAccordions(): InteractionModalAccordionsHook | null {
    return null;
  }

  public modalFooterComponent(): React.FC<InteractionModalFooterProps> | null {
    return null;
  }

  public analyticsCardComponent(): React.LazyExoticComponent<React.FC<AnalyticsCardProps>> {
    return AnalyticsClickCard;
  }

  public cardComponent(): React.FC<{ onClickHeader?: () => void }> {
    return CardMain.StandardCard;
  }

  public cardBodyComponent(): React.FC {
    return NoBodyCard;
  }

  // Minimum # of something common to the Modal and the Card
  public minRange(): number {
    return 0;
  }

  // Maximum # of something common to the Modal and the Card
  public maxRange(): number {
    return 0;
  }

  // Wants to show results
  public hasResultsToShow(): boolean {
    return false;
  }

  public renderColumnData(_data: RenderColumnData): RenderColumnData | null {
    return null;
  }

  public onlyExistsInPresentationRoom(): boolean {
    return false;
  }
}
